// extracted by mini-css-extract-plugin
module.exports = {"logos":"contact_logos__2DdJr","icon":"contact_icon__1-7he","wrapper":"contact_wrapper__3gij1","btn":"contact_btn__1Z1v2"};